import type { ColumnSizingInfoState, ColumnSizingState, HeaderGroup } from "@tanstack/react-table";
import { cn } from "../../lib/utils";
import { TableHeaderCell } from "./TableHeaderCell";

export type TableHeaderRowProps = {
	// biome-ignore lint/suspicious/noExplicitAny: legacy any
	headerGroups: HeaderGroup<any>[];
	setColumnSizing: (columnSizing: ColumnSizingState) => void;
	columnSizing: ColumnSizingState;
	columnSizingInfo: ColumnSizingInfoState;
	className?: string;
};

export const TableHeaderRow = ({
	headerGroups,
	setColumnSizing,
	columnSizing,
	columnSizingInfo,
	className,
}: TableHeaderRowProps) => (
	<div
		className={cn(
			"sticky z-20 top-0 left-0 right-0 h-[33px] min-w-fit flex bg-gray-100 border-b border-gray-200 select-none",
			className,
		)}
	>
		{headerGroups.map((headerGroup) => {
			return headerGroup.headers.map((header, index) => {
				if (header.id === "action_menu") {
					return null;
				}
				return (
					<TableHeaderCell
						key={index}
						header={header}
						columnSizingInfo={columnSizingInfo}
						columnSizing={columnSizing[header.id]}
						setColumnSizing={(newColumnSize) =>
							setColumnSizing({ ...columnSizing, [header.id]: newColumnSize })
						}
					/>
				);
			});
		})}
	</div>
);
